<div [ngClass]="[breakPointSize === 'xl' ? 'tablet-footer-margin' : '']"></div>
<div
  class="shimano-footer"
  [ngClass]="[activeCountry$ | async, activeLanguage$ | async]"
  *ngIf="footerData$ | async as footerData"
>
  <ng-container *ngFor="let link of footerData.links; index as footerLinkItem">
    <hr *ngIf="footerData.breakAfterIndex?.includes(footerLinkItem)" />
    <app-generic-link
      location="footer"
      [linkIconSrc]="link.media"
      linkIconStyleClass="footer-link-icon"
      [url]="link.url"
      [target]="link.target ? '_blank' : null"
      >{{ link.linkName }}</app-generic-link
    >
  </ng-container>
</div>
